<template>
	<perfect-scrollbar>
		<v-select
			v-model="localSelectedHeaders"
			:multiple="multipleSelect"
			chips
			:items="headers"
			hint="Choose the required headers"
			persistent-hint
		></v-select>
	</perfect-scrollbar>
</template>

<script>
export default {
	name: 'HeaderSelector',
	components: {},
	props: {
		headers: { type: Array },
		selectedHeaders: { type: [Array, String] },
		multipleSelect: { type: Boolean },
	},
	computed: {
		localSelectedHeaders: {
			get() {
				return this.selectedHeaders;
			},
			set(value) {
				this.$emit('update:selectedHeaders', value);
			},
		},
	},
};
</script>

<style scoped lang="scss">
.card-displayer {
	padding: 20px;
	width: 100%;

	::v-deep {
		.card-cell {
			// height is constant so that it works with a title for the cell
			height: auto !important;
		}
		.dummy-filler > div {
			background-color: #bebebf;
		}
	}
}

::v-deep .v-input__slot fieldset {
	border-color: #ced0da;
	background-color: #f5f8fe;
}
</style>
